<!-- 问卷创建方式之---空白创建 -->
<template>
    <div class="create-empty">
        <div class="nav-bar">
            <go-back title="返回" :content="$route.query.Qid ? '问卷查看编辑': '空白创建'"/>
            <section class="nav-bar--btns">
                <el-button type="primary" plain
                           size="small"
                           icon="el-icon-copy-document"
                           @click.stop="handleCopy"
                           style="min-width: 130px">复制问卷
                </el-button>
                <el-button type="primary"
                           plain size="small"
                           icon="el-icon-circle-check"
                           @click.stop="handleSave"
                           style="min-width: 130px">保存项目
                </el-button>
                <el-button type="primary"
                           size="small"
                           icon="el-icon-share"
                           @click.stop="handlePublish"
                           style="min-width: 200px">{{isPublish ? "分享" : "发布并分享"}}
                </el-button>
            </section>
        </div>
        <el-row type="flex">
            <a-side @onSideClick="handleSideClick"/>
            <el-scrollbar class="content-container"
                          tag="main"
                          wrap-class="content-container--wrapper"
                          view-class="content-container--view">
                <div class="content-header">
                    <input type="text" class="content-header--title" v-model="headerTitle"/>
                    <textarea
                        class="content-header--welcome"
                        ref="welcome"
                        rows="1"
                        :value="headerWelcome"
                        maxlength="200"
                        @input="onWelcomeChange"
                    />
                </div>
                <div v-if="!$route.query.Qid && questionList.length === 0" class="question-container-empty">
                    <div>点击题型</div>
                    <div>您也可以 <span class="pointer color-primary--text" @click.stop="openExample">导入项目</span></div>
                </div>
                <draggable class="question-container"
                           v-else
                           v-model="questionList"
                           :disabled="disabledDrag"
                           :scroll="true"
                           tag="ul">
                    <transition-group name="fade-bottom"
                                      type="transition">
                        <div class="question-list"
                             v-for="(question, index) in questionList"
                             @mouseenter.stop="(e) => onMouseenter(question, index)"
                             @mouseleave.stop="e => onMouseleave(question, index)"
                             :key="question.no">
                            <!-- 问卷编辑 -->
                            <question-edit :question.sync="question"
                                           v-if="currentIndex === index"
                                           class="question-edit"
                                           @cancel="onCancel($event, index, question)"
                                           ref="questionView"
                                           @confirm="() => onConfirm(question)"
                                           :number="getIndex(question, 'edit')"/>
                            <!-- 问卷展示 -->
                            <question-view :question.sync="question"
                                           v-else
                                           @click.native.stop="handleQuestionClick(question)"
                                           :number="getIndex(question,  'view')"/>
                            <tool-bar ref="toolBar" :index="index" :id="question.no"/>
                        </div>
                    </transition-group>
                </draggable>
            </el-scrollbar>
        </el-row>
        <publish-questionnaire ref="publish" @confirm="onPublish"/>
        <share ref="share" :query="{
            from: $route.query.from,
            Qid: publishVal.Id,
            isViewResult: publishVal.IsUserDispalyResult
        }" :questionnaire-title="headerTitle"/>
        <example ref="example">
            <el-row type="flex" justify="center">
                <el-button type="primary"
                           icon="el-icon-upload2"
                           @click.stop="handleImport">导入项目</el-button>
            </el-row>
        </example>
    </div>
</template>

<script>
// 侧边栏
import ASide from "./cpns/aside"
// 问卷展示
import QuestionView from "@/components/questionView";
// 问卷编辑
import QuestionEdit from "@/components/questionEdit"
// 分享
import Share from "./cpns/share"
// 问卷发布设置
import PublishQuestionnaire from "@/components/publishQuestionnaire";
// 移动
import draggable from "vuedraggable"
import Example from "./cpns/example";
// 工具栏
import ToolBar from "./cpns/toolbar"
import { QUESTION_VAL, TITLE, WELCOME, STEM, formatQuestionnaire, generateBackstageQuestionnaire } from "@/utils/question-config";
import { uuid, uploadOfInput, setUrlQuery } from "@/utils"
import { addQuestion, publishQuestionnaire, importQuestionnaire } from "@/api/new-question-iteration/question-library";
import { uploadFile } from "@/api/manage";
import { isEqual } from "lodash";
const QUESTIONNAIRE__INFO = "QUESTIONNAIRE__INFO"

export default {
    name: "CreateEmpty",
    componentName: "CreateEmpty",
    components: {
        ASide,
        QuestionView, // 问卷查看
        QuestionEdit, // 问卷编辑
        draggable,
        ToolBar,
        PublishQuestionnaire,
        Share,
        Example
    },
    data(vm) {
        const {
            title = TITLE,
            welcome = WELCOME,
            questionList = []
        } = JSON.parse(window.sessionStorage.getItem(QUESTIONNAIRE__INFO) || "{}")
        return {
            headerTitle: title, // 问卷标题
            headerWelcome: welcome, // 问卷欢迎语
            questionList, // 试题列表
            currentIndex: undefined,
            disabledDrag: false,
            publishVal: {},
            isPublish: String(vm.$route.query.isPublish) === "true"
        }
    },
    watch: {
        questionList: {
            handler(val) {
                this.questionOrderIndexedit = 0
                this.questionOrderIndexview = 0
                console.log(val, "value");
            },
            deep: true
        },
    },
    updated() {
        this.questionOrderIndexedit = 0
        this.questionOrderIndexview = 0
    },
    mounted() {
        const { scrollHeight } = this.$refs.welcome
        this.welcomeClientHeight = scrollHeight + 4
        this.$refs.welcome.style.height = (scrollHeight + 4) + "px"
        this.getQuestionnaireDetail()
    },
    methods: {
        handleSideClick(questionIndo) {
            const { text, val } = questionIndo
            this.questionList.push({
                text: text,
                type: val,
                stem: STEM,
                options: [QUESTION_VAL.single, QUESTION_VAL.multiple].includes(val)
                    ? Array.from({ length: 2 }, (item, index) => ({
                        type: "text",
                        text: "选项" + (index + 1)
                    })) : "",
                no: uuid(6)
            })
            this.currentIndex = this.questionList.length - 1
            this.disabledDrag = true
            this.$nextTick(() => {
                const view = this.$refs.questionView
                view[view.length - 1].focus(true, "stem")
            })
        },
        // 鼠标移入
        onMouseenter(question, i) {
            if (this.currentIndex === i) return
            const index = this.$refs.toolBar.findIndex(item => item.$el.id === question.no)
            this.$refs.toolBar[index].open()
        },
        // 鼠标移出
        onMouseleave(question, i) {
            if (this.currentIndex === i) return
            const index = this.$refs.toolBar.findIndex(item => item.$el.id === question.no)
            this.$refs.toolBar[index].close()
        },
        // 欢迎语变化
        onWelcomeChange(e) {
            const value = e.target.value
            this.$refs.welcome.style.height = this.welcomeClientHeight + "px"
            this.$refs.welcome.style.height = (e.target.scrollHeight + 2) + "px"
            this.headerWelcome = value
        },
        // 监听取消
        onCancel(original, index, question) {
            if (!isEqual(question, original)) {
                console.log("不相等");
                this.$set(this.questionList, index, original)
            }
            this.currentIndex = undefined
            this.disabledDrag = false
            this.questionOrderIndexview = 0
        },
        // 监听确认
        onConfirm(question) {
            this.currentIndex = undefined
            this.disabledDrag = false
            this.questionOrderIndexview = 0
        },
        // 处理试题点击
        handleQuestionClick(question) {
            const index = this.$refs.toolBar.findIndex(item => item.$el.id === question.no)
            this.$refs.toolBar[index].handleEdit(this)
        },
        // 导入项目
        handleImport() {
            uploadOfInput((file) => {
                uploadFile({ file }).then(url => {
                    importQuestionnaire(url).then(qid => {
                        formatQuestionnaire(qid, (data) => {
                            const { welcome, title, questionList } = data
                            this.headerTitle = title
                            this.headerWelcome = welcome
                            this.questionList = questionList
                            setUrlQuery({ Qid: qid })
                            this.$nextTick(() => {
                                this.$message.success("导入成功")
                                this.$refs.example.close()
                            })
                        })
                    })
                })
            }, undefined, ".doc,.docx")
            // this.$router.push({
            //     name: "CreateTextImport",
            //     query: {
            //         from: "CreateEmpty"
            //     }
            // })
        },
        // 发布问卷
        handlePublish() {
            if (this.isPublish) {
                this.$refs.share.open()
            } else {
                this.$refs.publish.open()
            }
        },
        // 监听发布
        onPublish(val, close) {
            const qid = this.$route.query.Qid
            if (qid) {
                this.publishQuestion(Object.assign(Object.create(null), val, { Id: qid }), close)
            } else {
                this.createQuestionnaire(close).then(qid => {
                    this.publishQuestion(Object.assign(Object.create(null), val, { Id: qid }), close)
                })
            }
        },
        // 创建问卷
        async createQuestionnaire(close) {
            const { headerTitle, headerWelcome, questionList } = this
            try {
                const qid = await addQuestion({
                    Id: this.$route.query.Qid,
                    ...generateBackstageQuestionnaire({ title: headerTitle, welcome: headerWelcome, questionList })
                })
                return qid
            } catch (e) {
                typeof close === "function" && close(true)
                return Promise.reject(e)
            }
        },
        // 发布问卷
        publishQuestion(val, close, isShare) {
            this.publishVal = val
            publishQuestionnaire(val).then(res => {
                this.$message.success("发布成功")
                typeof close === "function" && close()
                this.isPublish = true
                setUrlQuery({ isPublish: false })
                if (isShare !== false) {
                    this.$nextTick(() => {
                        this.$refs.share.open()
                    })
                }
            })
        },
        // 获取问卷详情
        getQuestionnaireDetail() {
            if (!this.$route.query.Qid) return
            formatQuestionnaire(this.$route.query.Qid, (res, raw) => {
                const {
                    welcome,
                    title,
                    questionList
                } = res
                this.headerWelcome = welcome
                this.headerTitle = title
                this.questionList = questionList
            })
        },
        // 处理保存
        handleSave() {
            this.createQuestionnaire().then(res => {
                setUrlQuery({ Qid: res })
                this.$route.query.Qid = res
                this.$message.success("保存成功")
            })
        },
        // 处理复制
        handleCopy() {
            // 复制之前先保存一次，以防该问卷在编辑之后没有保存
            this.createQuestionnaire().then(res => {
                setUrlQuery({ Qid: res })
                this.$route.query.Qid = res
                const { headerTitle, headerWelcome, questionList } = this
                addQuestion(generateBackstageQuestionnaire({
                    title: headerTitle,
                    welcome: headerWelcome,
                    questionList
                })).then(res => {
                    this.isPublish = false
                    setUrlQuery({ isPublish: false })
                    this.$message.success("复制成功")
                })
            })
        },
        openExample () {
            this.$refs.example.open()
        },
        // 获取index
        getIndex (question, type) {
            if (question.type === "textDesc") {
                return ""
            } else {
                if (this["questionOrderIndex" + type]) {
                    this["questionOrderIndex" + type] += 1
                } else {
                    this["questionOrderIndex" + type] = 1
                }
                return this["questionOrderIndex" + type]
            }
        }
    },
    beforeDestroy() {
        // 组卷销毁时清除保存的问卷信息
        window.sessionStorage.removeItem(QUESTIONNAIRE__INFO)
    }
}
</script>

<style scoped lang="less">
.create-empty {
    .nav-bar {
        margin: 0 auto;
        width: 100%;
        background-color: #fff;
        padding-left: 18.5%;
        padding-right: 30px;
        height: 70px;
        line-height: 70px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

}

.content-container {
    flex: 1;
    margin-left: 30px;
    box-sizing: border-box;
    margin-top: 30px;

    ::v-deep &--view {
        height: calc(100vh - 70px - 70px - 30px);
        display: flex;
        flex-direction: column;
    }

    ::v-deep &--wrapper {
        overflow-x: hidden;
    }
}

.content-header {
    background-color: #fff;
    margin-bottom: 30px;
    padding: 30px 400px 30px 30px;
    box-sizing: border-box;

    &--title, &--welcome {
        padding: 14px 20px;
        border: 1px dashed #fff;
        display: block;
        width: 100%;
        margin-bottom: 30px;
        transition: background-color, border .4s;
        box-sizing: border-box;

        &:hover {
            border-color: #BABFCB;
        }

        &:focus {
            background-color: #F4F4F4;
        }
    }

    &--title {
        font-size: 24px;
        font-weight: 500;
        color: #2F3134;
    }

}

.question-container {
    background-color: #fff;
    box-sizing: border-box;
    padding: 23px 100px;
    flex: 1;
}

.question-list {
    position: relative;
    transition: all .5s;
}

.question-edit {
    background-color: #F1F2F6;
}

.question-container-empty {
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    box-sizing: border-box;
    flex-direction: column;
    font-size: 17px;
    font-weight: 500;
    line-height: 30px;
}
</style>
